"use client";
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en"><body>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24, textAlign: "center" }}>
        <h2>Something went wrong</h2>
        <p>Please try again — your donations are safe.</p>
        <button onClick={reset} style={{ padding: "10px 24px", cursor: "pointer" }}>Reload</button>
      </div>
    </body></html>
  );
}
